/* eslint-disable @next/next/no-page-custom-font */
import "styles/globals.css";
import type { AppProps } from "next/app";
import "react-toastify/dist/ReactToastify.css";
import CartProvider from "../context/CartContext";
import initAuth from "lib/initAuth";
import UnhandledError from "components/UnhandledError";
import UserProvider from "context/UserContext";
import MenuProvider from "context/MenuContext";
import Head from "next/head";
import Script from "next/script";
import StylesProvider from "context/StylesContext";
import NextProgress from "next-progress";
import { useRouter } from "next/router";

initAuth();
function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  return (
    <>
      <Script
        strategy="lazyOnload"
        async
        id="tag_manager"
        src="https://www.googletagmanager.com/gtag/js?id=G-CZVM1GR7Z1"
      ></Script>
      <Script id="analytics" strategy="lazyOnload">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){
              dataLayer.push(arguments);
            }
            gtag('js', new Date());

            gtag('config', 'G-CZVM1GR7Z1');
        `}
      </Script>
      <Head>
        <meta
          name="description"
          content={
            pageProps.SEODescription ||
            "Con Simple puedes crear tu tienda online gratis y rápido, sin costos ni comisiones."
          }
        />
        <title>
          {pageProps.SEOTitle ||
            "Simple - crear tu tienda online gratis es posible"}
        </title>
        <meta
          property="og:image"
          content={
            pageProps.SEOImage ||
            "https://r2-image-worker.simpleapp.workers.dev/Logosimple.png"
          }
        />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          //@ts-ignore
          crossOrigin
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;700&family=Roboto:wght@100;300;400;500;700&family=Rochester&display=swap"
          rel="stylesheet"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta
          name="theme-color"
          content={
            pageProps.SEONavbarBackground
              ? pageProps.SEONavbarBackground
              : router.asPath.includes("/dashboard/")
              ? "#f9fafb"
              : "#ffffff"
          }
        />
      </Head>
      <NextProgress
        options={{ showSpinner: false }}
        height="4px"
        color="#2196F3"
      />
      <UnhandledError>
        <StylesProvider>
          <UserProvider key={pageProps.user?.id} user={pageProps.user}>
            <MenuProvider account={pageProps.account || pageProps.user}>
              <CartProvider>
                <Component {...pageProps} />
              </CartProvider>
            </MenuProvider>
          </UserProvider>
        </StylesProvider>
      </UnhandledError>
    </>
  );
}
export default MyApp;
